export default __webpack_public_path__ + "static/Personalized-Learning-e4b2056539eb352517fffed024b13c8f.webp";